import { defineMessages } from 'react-intl';

export default defineMessages({
    RetrievePreviousPayment: {
        id: 'qnb.common.failedDownloadPayment.RetrievePreviousPayment',
        defaultMessage: 'Retrieving your previous payment journey...'
    },
    CPARefresh: {
        id: 'qnb.common.failedDownloadPayment.CPARefresh',
        defaultMessage: 'Please don’t refresh or navigate away from this page.'
    }
});
